export var Theme;
(function (Theme) {
    Theme["light"] = "light";
    Theme["dark"] = "dark";
})(Theme || (Theme = {}));
export var ErrorStatus;
(function (ErrorStatus) {
    ErrorStatus["noSite"] = "Site was not found";
    ErrorStatus["noArticle"] = "Article was not found";
})(ErrorStatus || (ErrorStatus = {}));
